module.exports = __webpack_public_path__ + "img/hyatt-1.ae28cecd.png";